import "./_layout.scss";

import {ReactElement, ReactNode, useEffect, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";

import {getApp} from "@/api/application";
import {ErrorComponent} from "@/components/Error/Error";
import Aside from "@/components/Layout/Aside";
import {appIcon} from "@/types/application";

import Header from "./Header";

function Layout({children}: {children: ReactNode}): ReactElement {
  const [allApp, setAllApp] = useState<appIcon[] | undefined>(undefined);
  useEffect(() => {
    const getAllApp = async (): Promise<void> => {
      const applications = await getApp();
      setAllApp(applications);
    };
    getAllApp();
  }, []);
  return (
    <>
      <Header></Header>
      <main className="main">
        <ErrorBoundary
          fallback={
            <ErrorComponent
              text="Une erreur est survenue lors de la récupération de la page. Veuillez réessayer."
              buttonToRefresh={true}
            />
          }>
          {children}
          {allApp ? <Aside applications={allApp || undefined} /> : null}
        </ErrorBoundary>
      </main>
    </>
  );
}

export default Layout;
